import { render, staticRenderFns } from "./TheCarrousel.vue?vue&type=template&id=d0e92aea&"
import script from "./TheCarrousel.vue?vue&type=script&lang=js&"
export * from "./TheCarrousel.vue?vue&type=script&lang=js&"
import style0 from "./TheCarrousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports